export const TOP_SPORTS_PRIMARY_TAB_ID = 'top-sports-primary';
export const TOP_SPORTS_SECONDARY_TAB_ID = 'top-sports-secondary';
